import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../pages/Login.css";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import { FlagTH, FlagUS } from "../components/FlagIcon";
import API from "../config";

function VerifyOTP() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { lang, toggle } = useLanguage();
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const verifyOTP = async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${API}/api/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: state.email, otp })
      });
      const data = await res.json();
      if (!res.ok) { setMessage(data.message); setLoading(false); return; }
      navigate("/reset-password", { state: { email: state.email } });
    } catch (err) {
      setMessage("Cannot connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <button
        onClick={toggle}
        style={{ position: "fixed", top: 16, right: 16, background: "none", border: "none", cursor: "pointer", zIndex: 100 }}
        title={lang === "th" ? "Switch to English" : "เปลี่ยนเป็นภาษาไทย"}
      >
        {lang === "th" ? <FlagUS size={28} /> : <FlagTH size={28} />}
      </button>

      <div className="glass-card">
        <h4 className="text-center mb-4">{t(lang, "verifyOtpTitle")}</h4>

        <div className="input-group-glass">
          <label>{t(lang, "enterOtp")}</label>
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && verifyOTP()}
          />
        </div>

        <button className="glass-btn-login" onClick={verifyOTP} disabled={loading}>
          {loading ? t(lang, "verifying") : t(lang, "verifyBtn")}
        </button>

        {message && <p className="text-danger text-center mt-3">{message}</p>}
      </div>
    </div>
  );
}

export default VerifyOTP;
